import BigNumber from 'bignumber.js';

import { OrderInstruction, OrderSide, OrderType } from '#/api/orders';

export interface OrderFormState {
  readonly asset: string | null;
  readonly amount: BigNumber | null;
  readonly limitPrice: BigNumber | null;
  readonly type: OrderType;
  readonly side: OrderSide;
  readonly instruction: OrderInstruction;
}

export const INITIAL_STATE: OrderFormState = {
  asset: null,
  amount: null,
  limitPrice: null,
  type: 'LIMIT',
  side: 'BUY',
  instruction: 'GTC',
};
